import { Role, User } from '@/types';

// Hierarchy: super_user is highest (0), org_admin is middle (1), data_owner is lower (2)
export const ROLE_HIERARCHY: Role[] = ['super_user', 'org_admin', 'data_owner'];

/** Lower number = higher permission. */
const getRoleLevel = (role: Role): number => ROLE_HIERARCHY.indexOf(role);

export const hasRole = (currentRole: Role | undefined, requiredRole: Role): boolean => currentRole === requiredRole;

export const hasAnyRole = (currentRole: Role | undefined, requiredRoles: Role[]): boolean =>
  !!currentRole && requiredRoles.includes(currentRole);

/** Index 0 is the highest permission, hence `<=` rather than `>=`. */
export const hasMinimumRole = (currentRole: Role | undefined, requiredRole: Role): boolean => {
  if (!currentRole) return false;
  return getRoleLevel(currentRole) <= getRoleLevel(requiredRole);
};

export const isSuperAdmin = (currentRole: Role | undefined): boolean => currentRole === 'super_user';

export const isOrgAdmin = (currentRole: Role | undefined): boolean => currentRole === 'org_admin';

export const isDataOwner = (currentRole: Role | undefined): boolean => currentRole === 'data_owner';

/** Platform-wide, independent of any org-specific role. */
export const isGlobalSuperAdmin = (user: User | null | undefined): boolean => user?.is_super_admin ?? false;

export const getAllRoles = (): ReadonlyArray<Role> => ROLE_HIERARCHY;
